import YourePrimal from "../../../../src/components/blackout-poems/you-re-primal";
import * as React from 'react';
export default {
  YourePrimal,
  React
};